/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export const REDIRECT_PATH_QUERY_PARAM = 'redirectPath'
export const PROXY_PATH = '/web/proxy'
export const MOCK_PATH = '/web/mocks'
